import React from 'react';

import useGroupSubscription from '../../../../hooks/useGroupSubscription';
import useTeam from '../../../../hooks/useTeam';
import { Spinner } from '../../../BaseUI';
import SubscriptionOverview from '../../../Subscription/Gift/SubscriptionOverview';
import SettingsHeading from '../SettingsHeading';
import AddTeamMembers from './AddTeamMembers';
import EmailDomainForm from './EmailDomainForm';
import NameForm from './NameForm';
import SignupLink from './SignupLink';
import styles from './styles.module.scss';

const corporateSettingsPath = 'https://ti.theinformation.com/corporate?source=settings';

export default function Team() {
  const { teamSetting, isTeamLoading } = useTeam();
  const { data: recipients } = useGroupSubscription({ type: 'Team Subscription' });

  const hasPersistedTeam = !!teamSetting?.team?.id;

  return (
    <>
      {isTeamLoading ? (
        <Spinner />
      ) : (
        <div className={styles.teamSettings}>
          <div className={styles.teamSettingsSection}>
            <NameForm teamSetting={teamSetting} />
            {hasPersistedTeam && (
              <div data-test="team-access-settings">
                <div className={styles.description}>
                  <hr />
                  On your current plan, each additional team account costs $
                  {teamSetting.currentOffer.initialPrice}. If you are adding more than 10 people,
                  please reach out to us{' '}
                  <a href={corporateSettingsPath} target="_blank" rel="noreferrer">
                    here
                  </a>{' '}
                  for bulk pricing.
                  <hr />
                </div>

                <SignupLink team={teamSetting?.team} />
                <EmailDomainForm team={teamSetting?.team} />
                <AddTeamMembers />
              </div>
            )}
          </div>

          {hasPersistedTeam && (
            <div data-test="team-additional-settings">
              <div className={styles.teamSettingsSection}>
                <SettingsHeading title="Enterprise Functionality">
                  Need more enterprise functionality like SSO, advanced billing options, higher seat
                  counts, etc., reach out to{' '}
                  <a href="mailto:enterprise@theinformation.com">enterprise@theinformation.com</a>
                </SettingsHeading>
              </div>
              <div className={styles.teamSettingsSection}>
                <SettingsHeading title="Subscriptions">
                  You are currently supporting the following subscriptions for others to The
                  Information
                </SettingsHeading>
                {!!recipients && <SubscriptionOverview recipients={recipients} team={true} />}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
